import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';



export default function PageBasicInfoComponent ({handleFormChange,handleInnerFormChange, selectedRoute,websites,networks}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Page Name"
              name="PageName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PageName',

                )
              }}
              type="text"
              value={selectedRoute?.PageName}
          />
          
          <InputContainer
            label="WebSite Name"
            labelField="WebsiteName"
            list={websites}
            onValueChange={(event: any) => {
                handleInnerFormChange(
                event.target.value,
                'PlatformWebSiteId'
                
              );
            }}
            optionName='Choose Website'
            type="select"
            value={selectedRoute?.PlatformWebSiteId}
            valueField="Id"
        />
          <InputContainer
            label="Network WebPage"
                          onValueChange={(event: any) => {
                            handleInnerFormChange(
                              event,
                              'IsNetworkWebPageEnabled'
                            );
                          }}
                          type="checkbox"
                          value={selectedRoute?.IsNetworkWebPageEnabled}
                      />
                      {selectedRoute?.IsNetworkWebPageEnabled  && 
                             <InputContainer
                             label="Network Name" 
                                              labelField="Name"
                                              list={networks}
                                              onValueChange={( newValue: any) => {
                                                const valueData: any = newValue.map((option: any) => option?.value)
                                                handleFormChange(
                                                  valueData,
                                                  'NetworkMappings.NetworkIds',
                                                  selectedRoute?.NetworkMappings
                                                );
                                              }}
                                              type="multiselect"
                                              valueField="Id"
                                              value={selectedRoute?.NetworkMappings?.NetworkIds}
                          />
                      }
         <InputContainer
              label="PageVersionId"
              name="PageVersionId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'PageVersionId',

                )
              }}
              type="number"
              value={selectedRoute?.PageVersionId}
          />
        <InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
     'Remarks',

       )
     }}
 type="text"
 value={selectedRoute?.Remarks}
/>
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}